import { TradingPlatformName } from './../types'
export const RESTRICTED_DOMAINS: Array<{
    host: string
    platforms: Array<TradingPlatformName>
}> = [
        {
            host: "portal.thinktrader.com",
            platforms: ["ThinkTrader"]
        }
    ]

// The umbrella origin-path segment for the EU. Any EU/EEA country's alpha-2
// code is also treated as EU (see isEuOriginSrc in euCountries.ts); this is the
// catch-all path that maps the whole region to one origin.
export const EU_UMBRELLA_ORIGIN_SRC = 'eu'

// Upper bound on a stored origin-src value; guards against an over-long
// ?src param or referrer path segment bloating the persisted slice.
export const MAX_ORIGIN_SRC_LENGTH = 32